import React, { createContext, useState, useEffect } from 'react';

// Crear el contexto
export const LanguageContext = createContext();

// Proveedor del contexto
export const LanguageProvider = ({ children }) => {
    // Leer el idioma desde localStorage o usar un idioma predeterminado
    const initialLanguage = localStorage.getItem('language') || 'ES';
    const [language, setLanguage] = useState(initialLanguage);

    const toggleLanguage = () => {
        const newLanguage = language === 'ES' ? 'EN' : 'ES';
        setLanguage(newLanguage);
        localStorage.setItem('language', newLanguage); // Guardar el nuevo idioma en localStorage
    };

    // Asegurarte de sincronizar el idioma con localStorage al cargar
    useEffect(() => {
        localStorage.setItem('language', language);
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
